module.exports = __webpack_public_path__ + "img/logo.b34cf010.png";